<template>
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="input-group add-on">
        <input class="form-control"
               id="srch-term"
               name="srch-term"
               type="text"
               placeholder="Search"
               autocomplete="off"
               v-model="filterText"
               @keyup.enter="doFilter">
        <div class="input-group-append">
          <button class="btn btn-primary"
                  type="submit"
                  @click="doFilter">
            <i class="fas fa-search"></i>
          </button>
        </div>
        <button class="btn btn-outline-primary ml-2"
                @click="resetFilter">
          <i class="fas fa-sync-alt"></i>
        </button>
        <button class="btn btn-outline-success btn-sm ml-2"
                type="button"
                @click="addFilter">
          <i class="fas fa-plus"></i> Add Filter
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  const AddFilter =
    () => import('@/components/admin/mobile_filter/AddFilter.vue');
  export default {
    data() {
      return {
        filterText : '',
      };
    },
    methods : {

      /**
       * Filter action
       */
      doFilter() {
        this.$events.fire('filter-set-filter', this.filterText);
      },

      /**
       * Reset Filter
       */
      resetFilter() {
        this.filterText = '';  // clear the text in text input
        this.$events.fire('filter-reset-filter');
      },
      
      /**
       * Show Add Filter modal
       */
      addFilter() {
        this.$modal.show(AddFilter, {}, {
          height   : 'auto',
          adaptive : true,
        }, {
          'reload-table' : (event) => {
            this.$events.fire('reload');
          },
        });
      },
    },
    components : {},
  };
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/components/admin/media/filter-bar';
</style>